var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((_vm.submetas),function(submeta,id){return _c('li',{key:`submeta_${id}`},[_vm._v(" "+_vm._s(submeta.meta)+" "),_c('ol',_vm._l((submeta.acciones_especificas),function(meta_meta,i){return _c('li',{key:`meta_${i}`},[_vm._v(" "+_vm._s(meta_meta)+" ")])}),0)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }